export default __webpack_public_path__ + "static/media/Karen_Yankovich_AHV_In_Moms_We_Trust.d2a7015a.jpg";